'use strict';

var dependencies = ['ngCookies', 'ngSanitize', 'ngAria', 'ui.router', 'pascalprecht.translate', 'otpp.dispatch',
  'otpp-config', 'tmh.dynamicLocale', 'otpp-feature-toggles', 'ngFileUpload', 'ngFileSaver'];

if (window.OTPP && window.OTPP.ft && window.OTPP.ft.enableOverrides) {
  dependencies.push('feature-toggles-override');
}

angular.module('MemberApp', dependencies);
